module.exports = __webpack_public_path__ + "img/Weapon_242.d28941d9.png";